<template>
  <div class="filter">
    <component
      :is="componentType"
      v-model="selectedProxy"
      :label="label"
      :options="options"
      :placeholder="placeholder"
      :show-reset="showReset"
      :show-selections="showSelections"
    />
  </div>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    modelValue?: string[]
    include?: (string | number)[]
    label?: string
    placeholder?: string
    showSelections?: boolean
    isMultiSelect?: boolean
  }>(),
  {
    modelValue: () => [],
    include: () => [],
    label: 'Topic',
    placeholder: 'All Topics',
    showSelections: true,
    isMultiSelect: true,
  },
)
const emit = defineEmits(['update:modelValue'])
const { fetchTopics } = useStoryblokDataSources()
const { data: topics } = await fetchTopics()

const selected = computed({
  get: () => {
    return props.modelValue
  },
  set: (value) => {
    emit('update:modelValue', value)
  },
})

const componentType = computed(() =>
  getFormkitSelectComponentName(props.isMultiSelect),
)

const options = computed(() => {
  let availableOptions = [...(topics.value || [])]

  if (props.include.length) {
    availableOptions = availableOptions.filter((item) =>
      props.include.includes(item.value),
    )
  }

  return availableOptions.map((option) => ({
    label: option.name,
    value: option.value,
  }))
})

const showReset = computed(() => props.isMultiSelect)

const selectedProxy = computed({
  get: () => selected.value,
  set: (value) => {
    emit('update:modelValue', value)
    selected.value = value
  },
})
</script>
